import {
    CLEAR_PLAYING_STREAM,
    STREAM_PLAYING
} from 'webapp/player/actions';
import {
    ANALYTICS_READY,
    CLOSE_MODAL_MESSAGE,
    CONTENT_SELECT,
    CONTENT_UNSELECT,
    STREAM_SELECTING,
    STREAM_SELECT,
    STREAM_UNSELECT,
    DISPLAY_MODAL_MESSAGE,
    FETCH_EXTERNAL_CONFIG,
    FETCH_EMBEDDED_OPTIONS,
    INIT_APP_DATA,
    MEDIA_QUERY,
    PACKAGE_ID,
    PACKAGE_TIER,
    APP_RENDERED,
    PICKER_STREAMS_SELECT,
    PICKER_STREAMS_UNSELECT,
    PICKER_STREAMS_SELECT_ERROR,
    OPEN_PICKER_SUCCESS,
    OPEN_PICKER_ERROR,
    PICKER_AUTO_SELECT,
    PICKER_STATE_CLEAR
} from '../actions/appActions';

export default function appReducer(state = {
    isMobile: false,
    selectedContent: {},
    selectedStream: {},
    playingStream: {},
    previousContent: {},
    bootstrap: {},
    selectedAiringId: undefined,
    pickerStreams: []
}, action) {
    switch (action.type) {
        case APP_RENDERED:
            return { ...state, rendered: true };
        case ANALYTICS_READY:
            return { ...state, analytics: action.initData };
        case CLEAR_PLAYING_STREAM:
            return { ...state, playingStream: {} };
        case CLOSE_MODAL_MESSAGE:
            return {
                ...state,
                showModalMessage: false,
                messageType: '',
                messageData: undefined,
                lastMessageType: state.messageType,
                lastMessageData: state.messageData
            };
        case CONTENT_SELECT:
            return { ...state, previousContent: state.selectedContent, selectedContent: action.content };
        case CONTENT_UNSELECT:
            return { ...state, selectedContent: {} };
        case STREAM_SELECTING:
            return { ...state, selectingStream: action.stream };
        case STREAM_SELECT:
            return { ...state, selectingStream: undefined, selectedStream: action.stream, playbackMeta: action.playbackMeta };
        case STREAM_UNSELECT:
            return { ...state, selectingStream: undefined, selectedStream: {}, playbackMeta: undefined };
        case STREAM_PLAYING:
            return { ...state, playingStream: action.stream };
        case DISPLAY_MODAL_MESSAGE:
            return { ...state, showModalMessage: true, messageType: action.messageType, messageData: action.messageData };
        case FETCH_EXTERNAL_CONFIG:
            return { ...state, bootstrap: action.bootstrap };
        case FETCH_EMBEDDED_OPTIONS:
            return { ...state, options: action.options };
        case INIT_APP_DATA:
            return {
                ...state,
                appName: action.appName,
                adobePassEnv: action.adobePassEnv,
                apiEnv: action.apiEnv,
                configEnv: action.configEnv,
                country: action.country,
                device: action.device,
                env: action.env,
                isMobile: action.isMobile,
                lang: action.lang,
                sourceLang: action.sourceLang,
                location: action.location,
                messages: action.messages,
                enableSearch: action.enableSearch,
                packageId: action.packageId,
                tier: action.tier,
                edition: action.edition,
                webview: action.webview,
                renderTemplateType: action.renderTemplateType,
                newrelicInsertKey: action.newrelicInsertKey,
                newrelicAccountId: action.newrelicAccountId
            };
        case MEDIA_QUERY:
            return { ...state, mq: action.mq };
        case PACKAGE_ID:
            return { ...state, packageId: action.packageId };
        case PACKAGE_TIER:
            return { ...state, tier: action.tier };
        case PICKER_STREAMS_SELECT:
            return { ...state, pickerStreams: action.pickerStreams, pickerStreamsEventId: action.pickerStreamsEventId };
        case PICKER_STREAMS_UNSELECT:
            return { ...state, pickerStreams: [], pickerStreamsEventId: undefined };
        case PICKER_STREAMS_SELECT_ERROR:
            return { ...state, pickerStreamsError: action.error };
        case OPEN_PICKER_SUCCESS:
            return {
                ...state,
                openPicker: {
                    isSuccess: true,
                    id: action.payload.id,
                    retryTime: action.payload.retryTime
                }
            };
        case OPEN_PICKER_ERROR:
            return { ...state, openPicker: { isSuccess: false, error: action.error } };
        case PICKER_AUTO_SELECT:
            return { ...state, pickerAutoSelectStream: action.stream };
        case PICKER_STATE_CLEAR: {
            return { ...state, openPicker: {}, pickerAutoSelectStream: {} };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/appReducer.js